<template>
  <div class="reserve-order-list">
    <!-- filter -->
    <div class="list-filter">
      <div class="filter-date" @click="handlePopupDate">
        <van-icon name="todo-list-o" />
        <span>{{ formData.date || $t("recordsDateText") }}</span>
        <van-icon
          name="clear"
          v-if="formData.date"
          @click.prevent.stop="onClearDate"
        />
      </div>
      <div class="filter-status" @click="handlePopupStatus">
        <span>{{ formData.statusStr || $t("recordsStatusText") }}</span>
        <van-icon name="arrow-down" />
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="$t('noMore')"
      :loading-text="$t('loading')"
      @load="onLoad"
    >
      <div class="order-item" v-for="(item, index) in list" :key="index">
        <div class="order-item-header">
          <div class="order-item-header__info">
            {{ language == 'CN' ? item.privateroomGroupName : item.privateroomGroupNameEn }}
          </div>
          <div
            class="order-item-header__status"
            :style="{
              color: {
                1: '#FB7E22 ',
                2: '#999999',
                3: '#999999',
                4: '#999999',
                5: '#999999',
                6: '#999999',
              }[item.reserveStatus],
            }"
          >
            {{ { 1: $t('statusStr1'), 2: $t('statusStr2'), 6: $t('statusStr3'), 3: $t('statusStr4'), 4: $t('statusStr5'), 5: $t('statusStr6') }[item.reserveStatus] }}
          </div>
        </div>
        <div class="order-item-main">
          <div class="order-item-title">
            {{ language == 'CN' ? (item.privateroomInfo || {}).name : (item.privateroomInfo || {}).enName }}
          </div>
          <div class="order-item-info">
            <div class="order-item-info-item">
              <div class="order-item-info-item-label">
                {{ $t("paySuccessReserveTime") }}
              </div>
              <div class="order-item-info-item-value">
                {{ item.reserveDate }} {{ item.mealHourName }}
                {{ item.planReachtime }}
              </div>
            </div>
            <div class="order-item-info-split"></div>
            <div class="order-item-info-item">
              <div class="order-item-info-item-label">
                {{ $t("dinersNum") }}
              </div>
              <div class="order-item-info-item-value">
                {{ item.reserveNum }}{{ $t("capacityUnit") }}
              </div>
            </div>
          </div>
        </div>
        <div class="order-item-action">
          <div
            class="order-item-action__btn"
            v-if="item.canReserve"
            @click="handleCancelReservation(item)"
          >
            {{ $t("reserveStatus6") }}
          </div>
          <div
            class="order-item-action__btn detail"
            @click="
              $router.push('/location/reserve/order/detail?id=' + item.id)
            "
          >
            {{ $t("reserveStatus5") }}
          </div>
        </div>
      </div>
    </van-list>

    <van-calendar
      v-model="showPopupDate"
      :show-confirm="false"
      @confirm="onConfirmDate"
    />

    <van-popup v-model="showPopupStatus" round position="bottom">
      <van-picker
        show-toolbar
        :columns="statusList"
        @cancel="showPopupStatus = false"
        @confirm="onConfirmStatus"
      />
    </van-popup>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { Dialog } from "vant";
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,

      showPopupDate: false,
      showPopupStatus: false,

      pageQuery: {
        pageNum: 1,
        pageSize: 10,
      },

      formData: {},
      // 1 已预订 2 已取消 3 客未到清台 4已清台 5过期自动清台
      statusList: [
        {
          text: this.$t("statusStr0"),
          value: "",
        },
        {
          text: this.$t("statusStr1"),
          value: "1",
        },
        {
          text: this.$t("statusStr2"),
          value: "2",
        },
        {
          text: this.$t("statusStr3"),
          value: "6",
        },
        // {
        //   text: "客未到清台",
        //   value: "3",
        // },
        // {
        //   text: "已清台",
        //   value: "4",
        // },
        // {
        //   text: "过期自动清台",
        //   value: "5",
        // },
      ],
      language: ''
    };
  },
  created() {
    this.userinfo = JSON.parse(localStorage.getItem("customerInfoList"))[0];
    this.language = localStorage.getItem("language");
  },
  methods: {
    async onLoad() {
      try {
        const createTime = {};
        const date = this.formData.date;
        if (date) {
          const day = dayjs(date);
          createTime.createTimeStart = day.format("YYYY-MM-DD");
          createTime.createTimeEnd = day.add(1, "day").format("YYYY-MM-DD");
        }

        const res = await this.$logina.post(
          "/api/wxapp/privateroomReserve/pageList",
          {
            shopId: localStorage.getItem("shopId"),
            ...this.pageQuery,
            ...this.formData,
            customerId: this.userinfo.customerId,
            createTimeStart: createTime.createTimeStart,
            createTimeEnd: createTime.createTimeEnd,
          }
        );

        const resData = res.data;
        const data = resData.data;
        this.list = this.list.concat(data.list);
        if (data.list.length < this.pageQuery.pageSize) {
          this.finished = true;
        } else {
          this.pageQuery.pageNum++;
        }
      } finally {
        this.loading = false;
      }
    },
    // 刷新
    handleRefresh() {
      this.pageQuery.pageNum = 1;
      this.list = [];
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    handlePopupDate() {
      this.showPopupDate = true;
    },
    handlePopupStatus() {
      this.showPopupStatus = true;
    },
    onConfirmDate(e) {
      const date = dayjs(e).format("YYYY-MM-DD");
      this.$set(this.formData, "date", date);
      this.showPopupDate = false;
      this.handleRefresh();
    },
    onClearDate() {
      this.$set(this.formData, "date", undefined);
      this.showPopupDate = false;
      this.handleRefresh();
    },
    onConfirmStatus(e) {
      this.$set(this.formData, "reserveStatus", e.value);
      this.$set(this.formData, "statusStr", e.text);
      this.showPopupStatus = false;
      this.handleRefresh();
    },
    async handleCancelReservation(item) {
      await Dialog.confirm({
        title: this.$t("dialogTitle1"),
        message: this.$t("dialogMessage"),
      });
      await this.$logina.post("/api/wxapp/privateroomReserve/cancelByCustomer", {
        shopId: localStorage.getItem("shopId"),
        customerId: this.userinfo.customerId,
        id: item.id,
      });
      this.$toast.success(this.$t("cancelSuccess"));
      this.handleRefresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.reserve-order-list {
  font-size: 14px;
  line-height: 1;
  padding-bottom: calc(68px + env(safe-area-inset-bottom));

  .list-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 16px 20px;
    border-bottom: 10px solid #f7f7f7;
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #fff;

    .filter-date,
    .filter-status {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid rgba($color: #000000, $alpha: 0.1);
      border-radius: 6px;
      padding: 12px;
      color: #999999;

      font-size: 12px;

      span {
        flex: 1;
      }

      ::v-deep {
        .van-icon-todo-list-o {
          margin-right: 6px;
        }
      }
    }
  }

  .order-item {
    padding: 0 20px;
    border-bottom: 10px solid #f7f7f7;

    .order-item-header {
      border-bottom: 1px solid #f7f7f7;
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .order-item-header__info {
        font-size: 14px;
        color: #000000;
      }

      .order-item-header__status {
        font-size: 14px;
        color: #fb7e22;
      }
    }

    .order-item-main {
      padding: 20px 0;
      border-bottom: 1px solid #f7f7f7;

      .order-item-title {
        font-size: 22px;
        font-weight: 500;
        color: #000000;
        margin-bottom: 16px;
      }

      .order-item-info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .order-item-info-item {
          .order-item-info-item-label {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            margin-bottom: 8px;
          }

          .order-item-info-item-value {
            font-size: 14px;
            font-weight: 400;
            color: #000000;
          }
        }

        .order-item-info-split {
          width: 1px;
          height: 39px;
          background: #000000;
          opacity: 0.1;
        }
      }
    }

    .order-item-action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 16px 0;

      .order-item-action__btn {
        width: 50%;
        border: 1px solid rgba($color: #000000, $alpha: 0.2);
        border-radius: 4px;
        padding: 12px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;

        &.detail {
          border-color: #2085da;
          background-color: #2085da;
          color: #fff;
        }
      }
    }
  }
}
</style>
